import { useSelector } from 'react-redux';
import { analytics } from 'src/services';
import MemoryPreferencesForm from './MemoryPreferencesForm';
import {
  useMemoryPreferences,
  getTotalKeywordLength,
} from './useMemoryPreferences';

const GlobalPreferences = () => {
  const { currentPractitionerSettings } = useSelector((state) => ({
    ...state?.practitionerState,
  }));

  const isMemoryEnabled = currentPractitionerSettings?.note_preferences?.memory;
  const {
    currentKeywordInput,
    handleAddKeyword,
    handleRemoveKeyword,
    instructions,
    keywordError,
    keywords,
    setCurrentKeywordInput,
    setInstructions,
  } = useMemoryPreferences({
    endpoint: '/v2/memory/self',
    canSave: isMemoryEnabled,
    fallbackPreferences: currentPractitionerSettings?.note_preferences,
    fetchErrorLogMessage: 'Failed to fetch self memory preferences',
    saveErrorLogMessage: 'Failed to update self memory preferences',
    saveErrorToastMessage: 'Failed to save your memory preferences.',
    onAddKeyword: (newKeyword, totalKeywords) => {
      analytics.track('Keyword Added In Memory Preferences', {
        keyword: newKeyword,
        total_keywords: totalKeywords,
      });
    },
    onSaveSuccess: ({
      hasInstructionsChanged,
      hasKeywordsChanged,
      instructions: nextInstructions,
      keywords: nextKeywords,
    }) => {
      if (hasInstructionsChanged) {
        analytics.track('Knowledge Base Updated In Memory Preferences', {
          content_length: nextInstructions.length,
        });
      }

      if (hasKeywordsChanged) {
        analytics.track('Keywords Updated In Memory Preferences', {
          keyword_count: nextKeywords.length,
          total_characters: getTotalKeywordLength(nextKeywords),
        });
      }
    },
  });

  return (
    <MemoryPreferencesForm
      title="User Preferences"
      titlePopoverContent="Provide custom instructions to guide how AI generates content for you. These preferences will be applied across all your AI-generated notes."
      knowledgeBaseLabel="Knowledge Base"
      knowledgeBaseDescription="Add additional context about your specific working needs, or other nuances about note / code generation that templates may not cover."
      keywordLabel="Keyword detection"
      keywordDescription="Add up to 20 keywords or phrases to boost transcription accuracy."
      keywordPopoverContent="Provide a list of keywords or phrases (e.g., drug names, specific medical terms, proper nouns) that are frequently misspelled or misidentified during transcription. Adding them here helps improve accuracy."
      keywordPlaceholder="E.g: Zolpidem"
      emptyKeywordsText="No keywords added yet."
      instructions={instructions}
      setInstructions={setInstructions}
      keywords={keywords}
      currentKeywordInput={currentKeywordInput}
      setCurrentKeywordInput={setCurrentKeywordInput}
      keywordError={keywordError}
      handleAddKeyword={handleAddKeyword}
      handleRemoveKeyword={handleRemoveKeyword}
      disabled={!isMemoryEnabled}
    />
  );
};

export default GlobalPreferences;
